import { ReactElement, useMemo } from 'react'
import { Project_Goal_Feature } from 'src/@types/graphql'
import { GridColDef, useGridApiRef } from '@mui/x-data-grid-pro'
import { useGridTranslateHook } from 'src/shared/utils/hooks/grid-translate-hook'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { S } from 'src/shared/styled/S'
import { get } from 'lodash'
import { useUserLocale } from 'src/user/UserContext'

interface Props {
  features: Project_Goal_Feature[]
}

export const ProjectGoalRelatedFeaturesGrid = ({ features }: Props): ReactElement => {
  const gridTranslations = useGridTranslateHook()
  const gridRef = useGridApiRef()
  const { getMessage } = useMessageSource()
  const language = useUserLocale()

  const rows = useMemo(() => {
    return features.map((feature) => {
      return {
        id: feature.id,
        title: get(feature.feature_value.feature_config.names, language, ''),
      }
    })
  }, [features, getMessage])

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'title',
        flex: 1,
        headerName: getMessage('label.title'),
      },
    ],
    [getMessage],
  )
  return (
    <S.DataGrid.ViewEditMode
      rows={rows}
      columns={columns}
      autoHeight
      apiRef={gridRef as any}
      localeText={gridTranslations}
      disableColumnSelector
      disableColumnReorder
      disableColumnPinning
      disableRowSelectionOnClick
      hideFooter
      $viewMode
      sx={{ marginTop: 1 }}
    />
  )
}
